import {
  DEFAULT_LANGUAGE,
  LANGUAGE_STORAGE_KEY,
  SupportedLanguage,
  SUPPORTED_LANGUAGES,
} from './constants';

export const normalizeToSupportedLanguage = (
  raw: string | null | undefined,
): SupportedLanguage | null => {
  if (!raw) return null;
  const lower = raw.toLowerCase();
  const matched = SUPPORTED_LANGUAGES.find(
    (lang) => lower === lang || lower.startsWith(`${lang}-`),
  );
  return matched ?? null;
};

export const getStoredLanguage = (): SupportedLanguage | null => {
  try {
    const stored = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
    const normalized = normalizeToSupportedLanguage(stored);
    if (!normalized) return null;
    return SUPPORTED_LANGUAGES.includes(normalized) ? normalized : null;
  } catch {
    return null;
  }
};

export const setStoredLanguage = (lang: SupportedLanguage) => {
  try {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
  } catch {
    // ignore
  }
};

export const resolveBrowserLanguage = (): SupportedLanguage => {
  const browserCandidates =
    (typeof navigator !== 'undefined' && navigator.languages?.length
      ? navigator.languages
      : [typeof navigator !== 'undefined' ? navigator.language : '']) ?? [];

  for (const candidate of browserCandidates) {
    const normalized = normalizeToSupportedLanguage(candidate);
    if (normalized && SUPPORTED_LANGUAGES.includes(normalized)) return normalized;
  }

  return DEFAULT_LANGUAGE;
};

/**
 * Single boundary for initial app language resolution.
 * Later, migrate to: profile -> stored -> browser -> default.
 */
export const resolveInitialLanguage = (): SupportedLanguage => {
  return getStoredLanguage() ?? resolveBrowserLanguage();
};

